<template>
  <div class="shopping-cart container">
    <form @submit.prevent="submitCartReview" v-if="hasCart">
      <h1 id="wb-cont">{{ $t("carttitle") }}</h1>
      <div class="hidden">
        <input type="hidden" name="productFamily" value="reservation" />
        <input type="hidden" name="productId" :value="productId" />
        <input type="hidden" name="type" :value="tripType" />
        <input type="hidden" name="channel" value="websales" />
        <input type="hidden" name="departureDate" :value="departure" />
        <input type="hidden" name="from" :value="origin" />
        <input type="hidden" name="to" :value="destination" />
        <input type="hidden" name="fares" :value="fareString" />
        <input type="hidden" name="departureTrip" :value="departureTripId" />
        <input
          type="hidden"
          name="departureFareClass"
          :value="departureFareClass"
        />
      </div>
      <div class="container" role="list">
        <div class="cart-instructions-wrapper row">
          <div class="cart-summary-instructions col-sm-8 col-sm-push-2">
                      <h2>{{ $t("cartinstructions") }}</h2>
                      <p>{{ $t("instructions1") }}</p>
                      <p>{{ $t("instructions2") }}</p>
          </div>
        </div>
        <div class="cart-summary row">
          <div class="panel panel-primary col-sm-12">
            <div class="panel-heading row">
              <h2>{{ $t("summary") }}</h2>
              <button class="pull-right btn btn-primary" type="submit">
                {{ $t("nextcheckout") }}
              </button>
              &nbsp;
              <button
                @click.prevent="emptyCart"
                class="pull-right btn btn-link"
                style="margin-right: 10px"
              >
                <i class="fa fa-trash"></i>
                {{ $t("emptycart") }}
              </button>
            </div>
            <div class="panel-body">
              <ul class="list-unstyled">
                <li>
                  <span
                    >{{ cartInfo.items.tickets.length }}
                    {{ $tc("item", cartInfo.items.tickets.length) }}</span
                  >
                  <span class="pull-right"
                    >${{ cartInfo.items.tickets | totalPrice }}</span
                  >
                </li>
                <li>
                  <span>{{ $t("fees") }}</span>
                  <span class="pull-right"
                    >${{ cartInfo.displayFeesTotal }}</span
                  >
                </li>
                <li>
                  <span>{{ $t("taxes") }}</span>
                  <span class="pull-right"
                    >${{ cartInfo.displayTaxesTotal }}</span
                  >
                </li>
                <li class="summary-total">
                  <span>{{ $t("total") }}</span>
                  <span class="pull-right">${{ cartInfo.displayTotal }}</span>
                </li>
              </ul>
            </div>
          </div>
          
        </div>
        <div class="cart-details row">
          <h2>{{ $t("details") }}</h2>
          <cartItemsDetails />
        </div>
      </div>
      <div class="form-group text-center mini-widget--actions">
        <a
          href="#"
          class="btn btn-ghost btn-ghost-yellow mrgn-rght-md"
          @click.prevent="continueShopping"
          >{{ $t("continueshopping") }}</a
        >
        <button type="submit" id="cartReview" class="btn btn-primary">
          {{ $t("nextcheckout") }}
        </button>
      </div>
    </form>
    <div class="container" v-if="!hasCart">
      <h1 id="wb-cont">{{ $t("carttitle") }}</h1>
      <p>{{ $t("cartempty") }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import cartItemsDetails from "../components/cartItemsDetails";

export default {
  name: "ShoppingCartPage",
  components: {
    cartItemsDetails,
  },
  data() {
    return {};
  },
  watch: {},
  created() {
    this.$store.commit("getCountries");
    this.$store.commit("getPaymentMethods");
  },
  computed: {
    productId() {
      return this.$store.state.current_product._id;
    },
    origin() {
      return this.$store.state.originId;
    },
    destination() {
      return this.$store.state.destinationId;
    },
    fares() {
      return this.$store.state.selectedFaresStore;
    },
    tripDate() {
      return this.$store.state.departure;
    },
    passengerInformation() {
      return this.$store.state.passengers;
    },
    cartInfo() {
      return this.$store.state.cart;
    },
    hasCart() {
      return Object.keys(this.$store.state.cart).length;
    },
    ...mapState([
      "tripType",
      "departure",
      "fareString",
      "departureTripId",
      "departureFareClass",
      "trips",
      "cartTrips",
    ]),
  },
  methods: {
    continueShopping: function () {
      this.$router.push("/");
    },
    emptyCart: function () {
      this.$store.commit("RESET_TRIP");
      this.$store.commit("EMPTY_CART");
      this.$router.push("/");
    },
    submitCartReview: function () {
      this.$router.push("/cart/payment");
    },
  },
  filters: {
    totalPrice: function (fares) {
      return fares
        .reduce(function (a, b) {
          return Number(a) + Number(b["displayTotal"]);
        }, 0)
        .toFixed(2);
    },
    totalTaxes: function (taxes) {
      return taxes
        .reduce(function (a, b) {
          return Number(a) + Number(b["total"]);
        }, 0)
        .toFixed(2);
    },
  },
  // eslint-disable-next-line no-unused-vars
  //beforeRouteLeave(to, from, next) {
  // called when the route that renders this component is about to
  // be navigated away from.
  // has access to `this` component instance.

  //next();
  //}
};
</script>
<style lang="scss">
.cart-summary {
  h2 {
    color: #fff;
    margin: 0px;
    padding-left: 10px;
    display: inline-block;
    text-transform: initial;
  }
  .panel-primary {
    position: relative;
    z-index: 2;
    border-color: transparent;
    border-radius: 2px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    & > .panel-heading {
      background-color:#E2EDFC ;
      border-color: #E2EDFC;
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
      h2{color:#000; font-size: 30px;font-weight: 500;margin-top:10px;}
    }
    .btn-link {
      color: #000;
    }

  }
  ul li {
    font-size: 18px;
    color: #757070;
    position: relative;
    span {
      background-color: #fff;
      position: relative;
      z-index: 1;
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
    &:not(.summary-total)::after {
      bottom: 5px;
      position: absolute;
      content: "";
      display: block;
      width: 100%;
      border-bottom: 2px dashed #febc11;
    }
    &.summary-total {
      border-top: 3px solid #febc11;
      font-weight: bold;
      margin-top: 20px;
      padding-top: 10px;
    }
  }
}
.cart-summary-instructions {
  position: relative;
  z-index: 1;
  margin-bottom: 40px;
  background-color: #fff;
  color: #757070;
  border: 1px solid #B6B6B6;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  padding-top: 25px;
  padding-bottom: 15px;
  padding-right: 20px;
  h2 {
    padding-left: 25px;
    padding-bottom: 10px;
  }
  p {
    font-size: 15px;
    padding-left: 25px;
    font-weight: 300;
  }
}
</style>